import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useLoaderData } from 'react-router';
import { PageTitle } from '../../common/page-layout/page-title';
export function ThirdPartyLicensesPage() {
    const licensesText = useLoaderData();
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "Third-Party Licenses" }), _jsx("pre", { "data-test": "third-party-licenses-text", children: licensesText })] }));
}
